import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { SORT_COLUMNS } from './constants'

function ClubCardModalTableHeader({ onSort, sort }) {
  const { t: translate } = useTranslation()

  return (
    <div className="club-card-modal-table-header">
      <div className={classNames('row-wrapper flex-row', sort.order)}>
        <Box
          className={classNames('cell cell-no cursor-pointer', { active: sort.sortBy === SORT_COLUMNS.NO })}
          onClick={() => onSort(SORT_COLUMNS.NO)}
        >
          {translate('clubCardModal.no')}
        </Box>

        <Box
          className={classNames('cell cell-company cursor-pointer', { active: sort.sortBy === SORT_COLUMNS.COMPANY })}
          onClick={() => onSort(SORT_COLUMNS.COMPANY)}
        >
          <div className="flag" />

          {translate('clubCardModal.company')}
        </Box>

        <Box
          className={classNames('cell cell-shareClubCard cursor-pointer', { active: sort.sortBy === SORT_COLUMNS.SHARE_CLUB_CARD })}
          onClick={() => onSort(SORT_COLUMNS.SHARE_CLUB_CARD)}
        >
          {translate('clubCardModal.revenueClubCCC')}
        </Box>

        <Box
          className={classNames('cell cell-newClubCards cursor-pointer', { active: sort.sortBy === SORT_COLUMNS.NEW_CLUB_CARDS })}
          onClick={() => onSort(SORT_COLUMNS.NEW_CLUB_CARDS)}
        >
          {translate('clubCardModal.newClubCards')}
        </Box>

        <Box
          className={classNames('cell cell-application cursor-pointer', { active: sort.sortBy === SORT_COLUMNS.APPLICATION })}
          onClick={() => onSort(SORT_COLUMNS.APPLICATION)}
        >
          {translate('clubCardModal.application')}
        </Box>
      </div>
    </div>
  )
}

ClubCardModalTableHeader.propTypes = {
  onSort: PropTypes.func,
  sort: PropTypes.shape({
    order: PropTypes.string,
    sortBy: PropTypes.string,
  }),
}

export default ClubCardModalTableHeader
